import clsx from "clsx";
import { usePathname } from "next/navigation";

type Props = {
  onClick: (event: React.ChangeEvent<unknown>) => void;
  page: number;
  selected: boolean;
  disabled: boolean;
};
export const PaginationLink = ({ onClick, page, selected, disabled }: Props) => {
  const pathname = usePathname();

  const split = pathname.split("/") || [];
  let asPath = split.slice(1, split.length - 1);

  const maybeNumber: string | number | undefined = asPath[asPath.length - 1];

  if (typeof maybeNumber === "string" && !isNaN(Number.parseInt(maybeNumber))) {
    asPath = asPath.slice(0, asPath.length - 1);
  }

  const href = page === 1 ? `/${asPath.join("/")}/` : `/${asPath.join("/")}/${page}/`;

  if (href === pathname) {
    return (
      <div
        onClick={onClick}
        className={clsx("rounded-full w-10 h-10 grid place-items-center text-base leading-5 font-bold", {
          "text-primary": !selected,
          "bg-primary text-white": selected,
          "cursor-pointer hover:bg-primary/30": !disabled,
          "text-primary/30": disabled,
        })}
      >
        {page}
      </div>
    );
  }

  return (
    <a
      href={href}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      className={clsx("rounded-full w-10 h-10 grid place-items-center text-base leading-5 font-bold no-underline", {
        "text-primary": !selected,
        "bg-primary text-white": selected,
        "cursor-pointer hover:bg-primary/30": !disabled,
        "text-primary/30": disabled,
      })}
    >
      {page}
    </a>
  );
};
